import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'
import moment from 'moment'
import { computed, ref, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-template',
  props: {
    type: null,
    searchOptions: null,
    page: { default: () => ({
      searchKey: '',
      current: 1,
      pageSize: 10,
      filterTime: [],
    }) },
    total: { default: 0 },
    pagination: { type: Boolean, default: true },
    placeholder: null,
    showOperate: { type: Boolean, default: true },
    showDateFilter: { type: Boolean, default: false }
  },
  emits: ['update:page', 'onSearch'],
  setup(__props: any, { emit: emits }) {

const props = __props as { type: string, searchOptions: { label: string; value: string }[], page: {
      current?: number
      pageSize?: number
      searchKey?: string
      filterTime?: string[]
    }, total: number, pagination: boolean, placeholder?: string, showOperate: boolean, showDateFilter: boolean }



const inputRef = ref<HTMLSelectElement | null>()
const searchType = ref(props.searchOptions[0].value)
const page = computed(() => props.page)

const placeholder = computed(() => {
  const str = props.searchOptions.find(
    (it) => it.value === searchType.value
  )?.label
  const msg =
    props.placeholder ??
    `${translate('materialPage.filter.search')} ${translate(str)}`
  return msg
})

// 更新搜索key
function onSearchInputChange() {
  const { value } = inputRef.value ?? {}
  const obj = { ...page.value, searchKey: value }
  emits('update:page', obj)
}
// 更新搜索条件
function onSelectChange(e: Event) {
  const { value } = e.target as HTMLSelectElement
  searchType.value = value
}
// 分页触发
function onCurrentChange() {
  onSearch()
}
function onSizeChange(_: number, size: number) {
  page.value.current = 1
  page.value.pageSize = size
  onSearch()
}
// 搜索
function onSearch(pageCurrnent) {
  if (pageCurrnent) {
    page.value.current = pageCurrnent
  }
  const obj = { ...page.value }
  emits('update:page', obj)
  // 搜索
  emits('onSearch', {
    tempType: props.type,
    value: obj,
    selectType: searchType.value,
  })
}

// 日期选择配置项
const pickerOptions = {
  shortcuts: [
    {
      text: '最近一个月',
      onClick(picker: any) {
        // 最近一个月
        const start = moment().subtract(1, 'months').format('YYYY-MM-DD')
        const end = moment().format('YYYY-MM-DD')
        picker.$emit('pick', [start, end])
      },
    },
    {
      text: '最近半年',
      onClick(picker: any) {
        const end = moment().format('YYYY-MM-DD')
        const start = moment().subtract(6, 'months').format('YYYY-MM-DD')
        picker.$emit('pick', [start, end])
      },
    },
    {
      text: '最近一年',
      onClick(picker: any) {
        const end = moment().format('YYYY-MM-DD')
        const start = moment().subtract(1, 'years').format('YYYY-MM-DD')
        picker.$emit('pick', [start, end])
      },
    },
    {
      text: '全部',
      onClick(picker: any) {
        picker.$emit('pick', [])
      },
    },
  ],
}
// 日期选择器修改
function onDateChange() {
  onSearch()
}

function tranlateLang(key: string) {
  return translate(key)
}

return { __sfc: true,props, inputRef, searchType, page, emits, placeholder, onSearchInputChange, onSelectChange, onCurrentChange, onSizeChange, onSearch, pickerOptions, onDateChange, tranlateLang }
}

})